import { User } from "@redotech/redo-customer-portal-app/contexts/user";
import {
  CustomerJson,
  getPrimaryCustomerEmail,
} from "@redotech/redo-model/customer";

export function getUserDisplayEmail(
  user: User | undefined,
  customer: CustomerJson | undefined,
): string | undefined {
  return user?.guestEmail || getPrimaryCustomerEmail(customer) || user?.email;
}

export function getUserDisplayName(
  user: User | undefined,
  customer: CustomerJson | undefined,
): string | undefined {
  return user?.guestName || customer?.name || user?.name;
}
